<template>
  <div>
    <form
      style="width: 90%; margin-left: auto; margin-right: auto;"
      method="PATCH"
      @submit="submitReg"
    >
      <div>
        <h3 class="header_style">
          Update Arnergy Product
        </h3>
        <p>"{{ updateData.productType }}"</p>
        <hr />

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="productName"
            >Product Name</label
          >
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control form-control-lg"
              id="productName"
              v-model="regParams.producttype"
              :placeholder="updateData.productType"
              required
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="productDescription"
            >Product Description</label
          >
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control form-control-lg"
              id="productDescription"
              v-model="regParams.productdescription"
              :placeholder="updateData.productDescription"
              required
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="amountOs"
            >OS Amount</label
          >
          <div class="col-lg-8">
            <input
              type="number"
              class="form-control form-control-lg"
              id="amountOs"
              v-model="regParams.amountos"
              :placeholder="updateData.amountOs"
              required
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="monthlyAmountLo"
            >LO Amount</label
          >
          <div class="col-lg-8">
            <input
              type="number"
              class="form-control form-control-lg"
              id="monthlyAmountLo"
              v-model="regParams.monthlyamountlo"
              :placeholder="updateData.monthlyAmountLo"
              required
            />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-lg-4 col-form-label" for="tenureLo"
            >LO Tenure</label
          >
          <div class="col-lg-8">
            <input
              type="number"
              class="form-control form-control-lg"
              id="tenureLo"
              v-model="regParams.tenurelo"
              :placeholder="updateData.tenureLo"
              required
            />
          </div>
        </div>
        <hr />

        <div>
          <button
            type="submit"
            class="btn btn-info btn-block btn-lg p-signup__form-submit"
            @click="submitReg"
          >
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "UpdateArnergyProduct",
  props: ["updateData"],
  data() {
    return {
      errorsResult: {},
      regParams: {
        producttype: "",
        productdescription: "",
        amountos: "",
        monthlyamountlo: "",
        tenurelo: ""
      }
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "producttype":
            if (value === "null" || value === "NaN") {
              errors[field] = "Product Name cannot be empty.";
            }
            break;
          case "productdescription":
            if (value === "null" || value === "") {
              errors[field] = "Product description cannot be empty.";
            }
            break;
          case "amountos":
            if (value === "null" || value === "NaN") {
              errors[field] = "OS Amount cannot be empty.";
            }
            break;
          case "monthlyamountlo":
            if (value === "null" || value === "NaN") {
              errors[field] = "LO monthly amount cannot be empty.";
            }
            break;
          case "tenurelo":
            if (value === "null" || value === "NaN") {
              errors[field] = "LO tenure cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errorsResult = errors;
    },
    submitReg(e) {
      e.preventDefault();

      this.validateReg();

      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      const HTTP = this.$httpUtils.FASTHTTP;
      const url = `/product/update-products/${this.updateData.id}`;
      HTTP.patch(url, this.regParams)
        .then(res => {
          this.showSuccessMsg({ message: "Device Updated!" });
          location.reload();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.row {
  margin-bottom: 20px;
}
h3.header_style {
  font-weight: 600;
  font-size: 24px;
  text-align: left;
}
.form-group label {
  font-size: 14px;
  color: #606266;
}
.date-upload {
  background: transparent;
  border-radius: 3px;
  border: none;
  width: 100%;
  height: 50px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/AdminOnboarding/UpdateArnergyProduct.vue